import { queryClient } from "../App";

import { Fragment, type JSX, useCallback } from "react";

import { ConfigurationChildEventUnion } from "@plansoft-configuration-renderer/events";
import { useConfigurationEvent } from "@plansoft-configuration-renderer/framework";

/**
 * Demo on how to access internal state
 * @returns
 */
export function ConfigurationStateSpy(): JSX.Element {
  const onConfigurationEvent = useCallback(
    async (payload: ConfigurationChildEventUnion) => {
      if (payload.cfgEvent === "configuration-changed") {
        //invalidate Query after each change
        queryClient.invalidateQueries({ queryKey: ["productInfo"] });
        queryClient.invalidateQueries({ queryKey: ["getBillOfMaterial"] });
      }
    },
    [],
  );

  useConfigurationEvent({
    // onConfigurationStarted: onConfigurationEvent,
    // onConfigurationLoaded: () => console.log("**CFG** load"),
    // onConfigurationResumed: () => console.log("**CFG** resume"),
    onConfigurationEvent: onConfigurationEvent,
    // onConfigurationNavigation: () => console.log("**CFG** navigation"),
  });

  return <Fragment />;
}
